import React, { Fragment, useState, useContext } from 'react'
import { UrlServicesContext } from 'components/UrlServicesContext'
import { Redirect } from 'react-router-dom'

import { makeStyles, withStyles } from '@material-ui/core/styles'
import {
  Grid,
  Button,
  TextField,
  Snackbar,
  Slide,
  FormControl,
  Dialog,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import axios from 'axios'
import Alert from '@material-ui/lab/Alert'

import { cardBodyStyle } from 'assets/jss/material-dashboard-react/components/cardBodyStyle'

const useStyles = makeStyles(cardBodyStyle)

const MuiDialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(DialogContent)

const MuiDialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(DialogActions)

export default function EditQuestion(props) {
  const classes = useStyles()

  const [openAlert, setOpenAlert] = useState(false)
  const [mensaje, setMensaje] = useState('')
  const [error, setError] = useState('')
  const [openAlertSuccess, setopenAlertSuccess] = useState(false)
  const [mensaje_success, setmensaje_success] = useState('')
  const [returnLogin, setReturnLogin] = React.useState(false)

  let keyAuthorization = localStorage.getItem('Session')

  const { urlServices, keyAplication } = useContext(UrlServicesContext)

  let data = props.id

  const [values, setValues] = useState({
    id: data.id,
    name: data.statement,
    errorName: false,
  })

  const handleChange = (prop) => (event) => {
    setopenAlertSuccess(false)

    setValues({
      ...values,
      [prop]: event.target.value,
      errorName: false,
    })
    setOpenAlert(false)
  }

  const handleCloseDialog = (pro) => (event) => {
    props.exit()
  }

  const submitForm = (e) => {
    e.preventDefault()
    setError('')
    setopenAlertSuccess(false)

    if (values.name.length === 0) {
      setValues({ ...values, errorName: true })
      setMensaje('El campo "Nombre" es obligatorio.')
      setOpenAlert(true)
      setError('error')
    } else {
      const dataValue = {
        statement: values.name.toUpperCase(),
      }

      axios
        .put(`${urlServices}questions/${values.id}`, dataValue, {
          headers: {
            application: keyAplication,
            Authorization: 'Bearer ' + keyAuthorization,
          },
        })
        .then((response) => {
          setopenAlertSuccess(true)
          setmensaje_success('Registro guardado con éxito.')
          props.callBackRefresh()
        })
        .catch((e) => {
          if (e.response.status === 401) {
            setTimeout(() => {
              localStorage.clear()
              setReturnLogin(true)
            }, 200)
          } else {
            setMensaje('Error de conexión, intente más tarde.')
            setOpenAlert(true)
            setError('error')
          }
        })
    }
  }

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return
    }
    setOpenAlert(false)
  }

  if (returnLogin) {
    return <Redirect to="/" />
  }

  return (
    <Fragment>
      <Dialog
        fullWidth
        maxWidth="sm"
        onClose={handleCloseDialog(true)}
        aria-labelledby="customized-dialog-title"
        open={props.open}
        keepMounted
        scroll="body"
        // style={{ zIndex: 100 }}
        PaperProps={{
          classes: { root: classes.DialogStyle },
        }}
      >
        <MuiDialogContent dividers className={classes.styleDialogContent}>
          <Fragment>
            <Grid container spacing={2} className={classes.containerProfile}>
              <Grid item xs={12} sm={12}>
                <div className={classes.titleCardFilter}>Editar pregunta</div>
                <div className={classes.lineBottom}></div>
              </Grid>
              <Grid item xs={12} sm={12}>
                <FormControl style={{ width: '100%' }}>
                  <TextField
                    name="name"
                    value={values.name}
                    error={values.errorName}
                    onChange={handleChange('name')}
                    fullWidth
                    required
                    label="Nombre de la pregunta"
                    margin="dense"
                    autoComplete="off"
                    rows={4}
                    multiline
                    variant="outlined"
                  />
                </FormControl>
              </Grid>
              <Grid item xs={12} sm={12}>
                <br></br>
                <center>
                  <Button
                    type="submit"
                    className={classes.buttonSubmit}
                    onClick={submitForm}
                  >
                    Guardar
                  </Button>
                </center>
              </Grid>
              <Grid item xs={12} sm={12}>
                <center>
                  {openAlertSuccess ? (
                    <Alert severity="success">{mensaje_success}</Alert>
                  ) : (
                    ''
                  )}
                </center>
              </Grid>
            </Grid>
            <Snackbar
              open={openAlert}
              autoHideDuration={6000}
              anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
              onClose={handleClose}
            >
              <Slide direction="up" in={openAlert} mountOnEnter unmountOnExit>
                <Alert
                  onClose={handleClose}
                  severity={error === 'error' ? 'error' : 'success'}
                  elevation={6}
                  variant="filled"
                >
                  {mensaje}
                </Alert>
              </Slide>
            </Snackbar>
          </Fragment>
        </MuiDialogContent>
        <MuiDialogActions>
          <Button
            className={classes.buttonRight}
            onClick={handleCloseDialog(true)}
            style={{ marginRight: 25 }}
          >
            Cerrar
          </Button>
        </MuiDialogActions>
      </Dialog>
    </Fragment>
  )
}
